module.exports = __webpack_public_path__ + "static/media/csrddc_img2.2bf7443f.svg";